import React, { useEffect, useState } from 'react'
import { Pressable } from 'react-native'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { InputAction } from 'widgets/InputAction'
import { Modal } from 'widgets/Modal'
import { QRCode } from 'widgets/QRCode'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { generateDynamicLink } from 'utils/links'
import { copyProfileUrl, copyUpspaceUrl, getProfileLink, getUpspaceLink } from 'utils/links/links'

import { UserType } from 'types/user'

import { HeaderIcon, Separator } from './styled'

export const ReferralView = ({
  user: data,
  mode = 'member',
}: {
  user: UserType
  mode?: 'member' | 'coach'
}) => {
  const [link, setLink] = useState<string>('')
  useEffect(() => {
    if (mode === 'member') {
      generateDynamicLink(getProfileLink(data?.username as string)).then((dynamicLink) => {
        setLink(dynamicLink)
      })
    } else {
      generateDynamicLink(getUpspaceLink(data?.username as string)).then((dynamicLink) => {
        setLink(dynamicLink)
      })
    }
  }, [data?.username, mode])

  const copyToClipboard = async () => {
    if (mode === 'member') {
      await copyProfileUrl(data?.username as string)
    } else {
      await copyUpspaceUrl(data?.username as string)
    }
    handleClose()
  }
  const [isOpen, setOpen] = useState(false)

  const handleClose = () => setOpen(false)
  const openModal = () => setOpen(true)

  return (
    <Box flex={1}>
      <Box padding='md'>
        <Box padding='sm' justifyContent='center' align='center'>
          <Title fontWeight='semiBold'>Share</Title>
        </Box>

        <Box margin={{ top: 'lg' }} padding='sm'>
          <Text align='left' fontSize='md' fontWeight='bold'>
            Method 1: Share link
          </Text>
        </Box>

        <Box margin={{ top: 'xs', bottom: 'lg', horizontal: 'sm' }}>
          {link.length > 0 && (
            <InputAction
              value={link}
              action={copyToClipboard}
              actionContent='Copy link'
              type='light'
            />
          )}
        </Box>

        <Separator />

        <Box margin={{ top: 'sm', horizontal: 'sm' }}>
          <Text align='left' fontSize='md' fontWeight='bold'>
            Method 2: QR code
          </Text>
        </Box>

        <Box padding='sm'>
          <Text align='left' fontSize='sm' fontWeight='normal'>
            Display this QR code so the person you&lsquo;re referring can scan it and follow the
            link.
          </Text>
        </Box>

        <Box
          margin={{ top: 'xs', bottom: 'xl' }}
          padding='sm'
          borderRadius='sm'
          backgroundColor='grey'
          align='center'
        >
          <HeaderIcon>
            <Pressable onPress={openModal}>
              <Icon color='black' name='maximize-2' />
            </Pressable>
          </HeaderIcon>

          <Box padding='md' borderRadius='lg' backgroundColor='grey' align='center'>
            <Box padding='lg' borderRadius='sm' backgroundColor='white'>
              {link.length > 0 && <QRCode size={160} value={link} />}
            </Box>
          </Box>
        </Box>
      </Box>

      <Modal isVisible={isOpen} onClose={handleClose}>
        <Box
          borderRadius='sm'
          display='flex'
          align='center'
          justifyContent='center'
          flexDirection='column'
        >
          <QRCode size={280} value={link} />
        </Box>
      </Modal>
    </Box>
  )
}
